export enum TextureId {
  Vignette = "assets/images/fx/vignette.png",
  MeshyTitlePad = "assets/images/ui-main/mesh-pad.png",
  newMeshPad = "ui-main/screen-title-base.png",
  newMeshPadColorRing = "ui-main/screen-title-accent.png",
  newMeshPadTypeLabelPad = "ui-main/screen-title-underpad.png",
}
